import { FeedbackDialog } from '@ori-ui/components';
import { paperClasses, styled } from '@ori-ui/mui';

export const Root = styled(FeedbackDialog)(() => ({
  [`.${paperClasses.root}`]: {
    width: '500px',
  },
}));
export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));
